import { format } from 'date-fns';

import { TranslateFn } from 'hooks/useTranslate';
import { dateTimeFormat } from 'constants/formats';
import { Employee } from 'types';
import { getLastImportationDate } from 'utils/employees';

type EmployeesPageDescriptionProps = {
  employees?: Employee[];
  t: TranslateFn;
  lastImportationDate?: Date | string | null;
  hasFactorialIntegration?: boolean;
};

export const getEmployeesPageDescription = ({
  employees = [],
  t,
  lastImportationDate: lastImportFromCounts,
  hasFactorialIntegration = false,
}: EmployeesPageDescriptionProps) => {
  const lastImportDate =
    lastImportFromCounts ??
    (employees?.length ? getLastImportationDate(employees) : null);

  return (
    <>
      {t('LastImportationDate')}:&nbsp;
      <b>
        {lastImportDate && hasFactorialIntegration
          ? format(new Date(lastImportDate), dateTimeFormat)
          : 'N/A'}
      </b>
    </>
  );
};
